<template>
  <div>
    <router-link :to="{ name: 'external-payments', params: {id: loan.reference}  }"
                 class="btn btn-primary btn-lg btn-block">
      {{ $t('LoanDetailsPage.payNow') }}
    </router-link>
    <div class="text-center pt-3" v-if="showCalculator">
      <router-link :to="{
        name: 'loan-payment-calculator',
        params: getCalculatorParams()
      }" class="small">
        {{ $t('LoanDetailsPage.whatIfLatePayment') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoanCardActions',
  props: ['showCalculator', 'loan'],

  methods: {
    getCalculatorParams() {
      return { reference: this.loan.reference, expectedDate: this.getExpectedDate(), amount: this.loan.toBePaid, loanStatus: this.getLoanStatus() }
    },
    getExpectedDate() {
      if (this.isDelayed()) {
        const d = new Date()
        const year = d.getFullYear()
        const month = ('0' + (d.getMonth() + 1)).slice(-2)
        const day = ('0' + d.getDate()).slice(-2)
        return `${year}-${month}-${day}`
      } else {
        return this.loan.nextPaymentDate
      } 
    },
    getLoanStatus() {
      return this.isDelayed() ? 'delayed' : 'normal'
    },
    isDelayed() {
      return this.loan.status === 'DELAYED'
    }
  }
}
</script>
